import React, { useEffect } from 'react'

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeContent = () => {


    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <div className='HomeContent_section' data-aos="zoom-in" data-aos-duration="1500">
            <div className='container-fluid'>
                <div className=''>
                    <h4>Our Biggest Campus for Education</h4>
                    <p>Welcome to Hamo Tech's largest education campus, where innovation meets state-of-the-art infrastructure. Spread over a vast area, our campus is designed to foster a creative and dynamic learning environment, providing students with the tools and resources they need to succeed in the world of technology.</p>
                </div>
            </div>
        </div>
    )
}

export default HomeContent
